/**
 *
 * @param  {...String|null} names
 * @returns {String}
 */
export const cn = (...names) =>
  names.filter(value => !!value && typeof value === 'string').join(' ')

